import { useEffect } from "react";

import { useTenantPresentation } from "@/hooks/use-tenant-presentation";
import { metadataForTenant, updateDocumentMetadata } from "@/lib/tenant-metadata";

/**
 * Keeps live browser metadata aligned with the current presentation model.
 * Crawlers that do not execute SPA JavaScript still see the neutral static tags.
 */
export function TenantMetadata() {
  const presentation = useTenantPresentation();

  useEffect(() => {
    updateDocumentMetadata(metadataForTenant(presentation));
  }, [presentation]);

  return null;
}
